import Form from 'components/form/form.component';
import styled from 'styled-components';

export const CustomForm = styled(Form)`
  && .input-container {
    margin-bottom: 1rem;
  }
`;
